import {RevenueModelType} from "../../../__generated__/generated_types";
import {getRevenueModelDisplayName} from "../../../constants/Strings";
import {userIsInternal} from "../../../authorization/AuthorizationCheckers";
import {AuthUser} from "../../../contexts/auth_types";

// We only Original and LeaseUp for selections at this point.
export const REVENUE_MODEL_OPTIONS = [
    {value: RevenueModelType.Original, label: getRevenueModelDisplayName(RevenueModelType.Original)},
    {value: RevenueModelType.LeaseUp, label: getRevenueModelDisplayName(RevenueModelType.LeaseUp)},
    {value: RevenueModelType.Affordable, label: getRevenueModelDisplayName(RevenueModelType.Affordable)},
];

export function getRevenueModelsForUser(user: AuthUser | null): typeof REVENUE_MODEL_OPTIONS {
    if(userIsInternal(user)) {
        return REVENUE_MODEL_OPTIONS;
    }
    return REVENUE_MODEL_OPTIONS.filter(option => option.value !== RevenueModelType.Affordable);
}

export const DEFAULT_REVENUE_MODEL = RevenueModelType.Original;